import { Stack, styled } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'

import { PATHS } from '@/router/constants'
import InfoComponent from '@/ui/organisms/InfoComponent'

const StyledDiv = styled(Stack)(`
  justify-content: center;
  align-items: center;
  align-self: center;
  width: 100%;
  height: 100%;
  gap: 2rem;
`)

const StepFour: React.FC = () => {
  const navigate = useNavigate()

  return (
    <StyledDiv maxWidth='31.25rem'>
      <InfoComponent
        title='Check your inbox'
        description='Use the link on the email we just sent to validate your email.'
        image='/images/mail-illustration.svg'
        imageAlt='Mail Illustration'
        buttonMessage='Go to Login Page'
        buttonOnClick={() => {
          navigate(PATHS.LOGIN)
        }}
      />
    </StyledDiv>
  )
}

export default StepFour
